// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CollegeDashboard from "./pages/CollageDashboard";
import Profile from "./pages/Profile";
import Opros from "./pages/Opros";
import OprosPage from "./pages/OprosPage";
import LoginPage from "./pages/LoginPage";
import OperatorDashboard from "./pages/OperatorDashboard";
import CollegeViewPage from "./pages/CollageViewPage";
import SurveyReviewPage from "./pages/ManagerPage";


const App = () => (
  <Router>
    <Routes>
      <Route path="/" >
        <Route path="dashboard" element={<CollegeDashboard />} />
        <Route path="college" element={<OperatorDashboard />} />
        <Route path="college/1" element={<CollegeViewPage />} />
        <Route path="profile" element={<Profile />} />
        <Route path="opros" element={<Opros />} />
        <Route path="opros/1" element={<OprosPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="manager" element={<SurveyReviewPage />} />

      </Route>
      <Route path="*" element={<div>404 Not Found</div>} />
    </Routes>
  </Router>
);

export default App;
